import React from 'react';

import cn from 'classnames';

import { Icon } from '@shared/ui';

import cls from './FileItem.module.css';

interface IFileItemActions {
    onClickHandler: (e: React.MouseEvent<HTMLElement>) => void;
    innerRef: (el: HTMLElement | null) => void;
    isVisible: boolean;
}

export const FileItemActions = ({ onClickHandler, innerRef, isVisible }: IFileItemActions) => (
    <span
        className={cn(cls.fileItemActions, isVisible && cls.isVisible)}
        onClick={(e) => {
            e.stopPropagation();
            onClickHandler(e);
        }}
        ref={innerRef}
    >
        <Icon iconName="moreActionsDots" />
    </span>
);
